import React from "react";
import EmergencyBanner from "./EmergencyBanner";
import { useNotifications } from "./useNotifications";

const EmergencyBannerContainer = () => {
  const { emergencyNotification } = useNotifications();
  
  return (
    <>
      {emergencyNotification && emergencyNotification.length > 0 && (
      <div className="sticky top-[6vh] left-0 right-0 z-20 w-full bg-red-600">
        <EmergencyBanner notification={emergencyNotification} />
      </div>
    )}
    </>
  );
};

export default EmergencyBannerContainer;